export default function ItemBagSVG({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="#39e29d"
      width={14}
      height={20}
      id="noun_game_ui_item_bag_2360112"
      viewBox="0 0 14 20"
    >
      <path
        id="Path_146"
        d="M107.052 189.015s4-.349 5.521 6.418c0 0 .9 3.838-.242 5.477 0 0-.552 1.322-3.312 1.322h-6.348a3.728 3.728 0 0 1-2.857-1.3 3.646 3.646 0 0 1-.834-2.6 5.549 5.549 0 0 1 2.348-4.233 7.032 7.032 0 0 0 1.106-.988 6.721 6.721 0 0 0 1.168-1.651 4.11 4.11 0 0 1 3.45-2.445z"
        transform="translate(-98.975 -182.233)"
      />
      <path
        id="Path_147"
        d="M250.382 131.315a2.213 2.213 0 0 0-.037.612.592.592 0 0 0 .62.547 6.387 6.387 0 0 1 2.341.284.6.6 0 0 0 .759-.325l.008-.018a.589.589 0 0 0-.1-.625 3.774 3.774 0 0 0-3.02-.94.59.59 0 0 0-.571.465z"
        transform="translate(-243.618 -126.39)"
      />
      <path
        id="Path_148"
        d="M215.262 45.647a3.531 3.531 0 0 1 1.944-.577.4.4 0 0 1 .4.4v2.216a.4.4 0 0 1-.318.392l-.372.078a.4.4 0 0 1-.259-.032 3.15 3.15 0 0 1-1.56-2.032.4.4 0 0 1 .165-.445z"
        transform="translate(-209.918 -44.378)"
      />
      <path
        id="Path_149"
        d="M290.242 30.491l-.22 2.453a.451.451 0 0 0 .355.481 3.861 3.861 0 0 1 1.494.692.451.451 0 0 0 .578-.038 6.565 6.565 0 0 1 2.557-1.521.783.783 0 0 0 .367-1.262 5.146 5.146 0 0 0-4.328-1.565.838.838 0 0 0-.803.76z"
        transform="translate(-281.564 -29.724)"
      />
      <path
        id="Path_150"
        d="M157.759 108.264a7.913 7.913 0 0 1 2.209 1.127.52.52 0 0 1 .206.469 4.076 4.076 0 0 0 0 .74.52.52 0 0 1-.236.48 5.668 5.668 0 0 0-1.134.968.49.49 0 0 1-.74 0 .488.488 0 0 1-.024-.608 2.245 2.245 0 0 1 .676-.608.389.389 0 0 0 .191-.3.389.389 0 0 0-.192-.374 4.685 4.685 0 0 0-1.312-.519.7.7 0 0 1-.551-.718.225.225 0 0 1 0-.049.693.693 0 0 1 .908-.6z"
        transform="translate(-154.275 -104.777)"
      />
    </svg>
  );
}
